import { ProductSku } from "../../types";

export const addons = {
	[ProductSku.ForetagarnaMembership]: {
		title: {
			sv: "FÖRETAGARNA MEDLEMSKAP",
		},
		addButtonTitle: {
			sv: "medlemskap",
		},
		description: {
			sv: "Text text",
		},
		removeTitle: {
			sv: "Ta bort?",
		},
		removeDescription: {
			sv: " Du kan lägga till ett FÖRETAGARNA MEDLEMSKAP igen under Välj produkter.",
		},
		externalLink: {
			sv: "https://www.svea.com/sv-se/foretag/",
		},
		moreAbout: {
			sv: "Läs mer",
		},
	},
	[ProductSku.ForetagarnaDebitCard]: {
		title: {
			sv: "Företagarna bankkort",
		},
		addButtonTitle: {
			sv: "bankkort",
		},
		description: {
			sv: "Reseförsäkring ingår.",
		},
		removeTitle: {
			sv: "Ta bort?",
		},
		removeDescription: {
			sv: " Du kan lägga till ett Företagarna bankkort igen under Välj produkter.",
		},
		externalLink: {
			sv: "https://www.svea.com/sv-se/foretag/f%c3%b6retagsbanken/bankkort",
		},
		moreAbout: {
			sv: "Mer om bankkortet",
		},
	},
	[ProductSku.ForetagarnaCreditCard]: {
		title: {
			sv: "Företagarna kreditkort",
		},
		addButtonTitle: {
			sv: "kreditkort",
		},
		description: {
			sv: "Upp till 1 miljon i kredit. Upp till 45 dagar utan ränta. Reseförsäkring och fri tillgång till flygplatslounger.",
		},
		removeTitle: {
			sv: "Ta bort?",
		},
		removeDescription: {
			sv: " Du kan lägga till ett Företagarna kreditkort igen under Välj produkter.",
		},
		extraCreditCards: {
			sv: "Extra kreditkort",
		},
		externalLink: {
			sv: "https://www.svea.com/sv-se/foretag/f%c3%b6retagsbanken/kreditkort",
		},
		moreAbout: {
			sv: "Mer om kreditkortet",
		},
	},
	[ProductSku.CreditCard]: {
		title: {
			sv: "Svea Kreditkort",
		},
		addButtonTitle: {
			sv: "kreditkort",
		},
		description: {
			sv: "Upp till 1 miljon i kredit. Upp till 45 dagar utan ränta. Reseförsäkring och fri tillgång till flygplatslounger.",
		},
		removeTitle: {
			sv: "Ta bort Svea Kreditkort?",
		},
		removeDescription: {
			sv: " Du kan lägga till ett Svea Kreditkort igen under Välj produkter.",
		},
		extraCreditCards: {
			sv: "Extra kreditkort",
		},
		externalLink: {
			sv: "https://www.svea.com/sv-se/foretag/f%C3%B6retagsbanken/kreditkort",
		},
		moreAbout: {
			sv: "Mer om kreditkortet",
		},
	},
	[ProductSku.DebitCard]: {
		title: {
			sv: "Svea Bankkort",
		},
		addButtonTitle: {
			sv: "bankkort",
		},
		description: {
			sv: "Reseförsäkring ingår.",
		},
		externalLink: {
			sv: "https://www.svea.com/sv-se/foretag/f%C3%B6retagsbanken/bankkort",
		},
		moreAbout: {
			sv: "Mer om bankkortet",
		},
	},
	[ProductSku.CheckCredit]: {
		title: {
			sv: "Kontokredit",
		},
		addButtonTitle: {
			sv: "kontokredit",
		},
		description: {
			sv: "Uppgradera ditt företagskonto – ansök om upp till 1 miljon kronor och få svar direkt.",
		},
		removeTitle: {
			sv: "Ta bort Kontokredit?",
		},
		removeDescription: {
			sv: " Du kan lägga till Kontokredit igen under Välj produkter.",
		},
		externalLink: {
			sv: "https://www.svea.com/sv-se/foretag/f%C3%B6retagsbanken/kontokredit",
		},
		moreAbout: {
			sv: "Mer om kontokredit",
		},
	},
	[ProductSku.Businessloan]: {
		title: {
			sv: "Företagslån",
		},
	},
	[ProductSku.Sparkonto]: {
		title: {
			sv: "Sparkonto",
		},
		description: {
			sv: "Sparkonto",
		},
	},
	[ProductSku.Utlandsbetalning]: {
		title: {
			sv: "Utlandsbetalning",
		},
	},
	[ProductSku.Bankgiro]: {
		title: {
			sv: "Bankgiro",
		},
		altTitle: {
			sv: "Bankgironummer",
		},
		description: {
			sv: "Bankgiro",
		},
	},
	[ProductSku.Transaktionskonto]: {
		title: {
			sv: "Företagskonto",
		},
		description: {
			sv: "Transaktionskonto",
		},
	},
	[ProductSku.DatasharingConsent]: {
		title: {
			sv: "Datadelning",
		},
	},
	[ProductSku.PaymentsCheckout]: {
		title: {
			sv: "Svea Checkout betallösning",
		},
	},
	[ProductSku.SwishCBase]: {
		title: {
			sv: "Swish Företag",
		},
	},
	[ProductSku.SwishCommerce]: {
		title: {
			sv: "Swish Handel",
		},
	},
	[ProductSku.SwishPayout]: {
		title: {
			sv: "Swish Utbetalning",
		},
	},
	[ProductSku.BankCertificateFee]: {
		title: {
			sv: "Bankintygsavgift",
		},
	},

	unavailable: {
		sv: "Produkten är inte tillgänglig för tillfället",
	},
};
